import axios from 'axios';
import _ from 'lodash';

const api = axios.create();

export const updateDefaultsSticky = async (axiosInstance, properties = {}) => {
  const instance = axiosInstance;
  await _.merge(instance.defaults, properties);
  return instance;
};

export default api;
